import { getAccessToken } from '@auth0/nextjs-auth0';
import { HttpClientPlugin } from '../types';
import { AUTH0_MISSING_ACCESS_TOKEN_MESSAGE } from '@/src/lib/utils/constants';


export function createWithAuthPlugin(): HttpClientPlugin {
  return {
    async beforeRequest(url, options) {
      const { withAuth = false } = options;
      if (!withAuth) {
        return { url, options };
      }

      let accessToken: string | null;

      try {
        accessToken = await getAccessToken();
      } catch (_) {
        return { url, options };
      }

      if (!accessToken) {
        throw new Error(AUTH0_MISSING_ACCESS_TOKEN_MESSAGE);
      }

      options.headers = new Headers(options.headers);
      options.headers.set('Authorization', `Bearer ${accessToken}`);

      return { url, options };
    },
  };
}
